module.exports = "https://cdn.littlereply.com/tt/resource/nav_icon_back.4def130a67459d6d69f5f4a0e3c1db1f.png";